// Set-Top Box page content
export const STB_PAGE = {
  en: {
    overline: "Set-Top Boxes",
    title_a: "Branded hardware.",
    title_b: "Preloaded with your app.",
    subtitle: "Push2Stream STBs ship to your subscribers in your packaging, with your app and your logo on boot. We handle firmware, certification, logistics and after-sales replacement.",
    models_overline: "Three models",
    models_title_a: "Pick the box that",
    models_title_b: "matches your audience.",
    fulfillment_overline: "Fulfillment",
    fulfillment_title: "Box. Brand. Boot.",
    fulfillment_subtitle: "From bare hardware to a subscriber holding your remote — we handle every step of the supply chain.",
    fulfillment_steps: [
      { title: "Custom firmware", desc: "Your app preloaded, your brand on boot, your launcher as the home screen. Auto-updates from our OTA server." },
      { title: "Branded packaging", desc: "Box, sleeve, manual and remote — all printed in your colors. We coordinate with your design team or ours." },
      { title: "Global logistics", desc: "Bulk shipping from regional warehouses (US / EU / LATAM / Africa). Customs and import handled." },
      { title: "After-sales replacement", desc: "RMA program with regional swap stock. Failed units replaced in under 5 business days." },
    ],
    cta_title_a: "Need to ship boxes?",
    cta_title_b: "Let's quote your batch.",
    cta_sub: "From 500 units pilot runs to 100,000+ deployments — tell us your geography and timeline.",
  },
  fr: {
    overline: "Décodeurs (STB)",
    title_a: "Matériel à votre marque.",
    title_b: "Préchargé avec votre app.",
    subtitle: "Les STBs Push2Stream sont expédiés à vos abonnés dans votre packaging, avec votre app et votre logo au boot. Nous gérons firmware, certification, logistique et remplacement après-vente.",
    models_overline: "Trois modèles",
    models_title_a: "Choisissez le décodeur",
    models_title_b: "qui correspond à votre audience.",
    fulfillment_overline: "Distribution",
    fulfillment_title: "Boîte. Marque. Boot.",
    fulfillment_subtitle: "Du carton au salon — nous gérons chaque étape de la chaîne logistique.",
    fulfillment_steps: [
      { title: "Firmware sur mesure", desc: "Votre app préchargée, votre marque au boot, votre launcher en page d'accueil. Mises à jour automatiques via notre serveur OTA." },
      { title: "Packaging à votre marque", desc: "Boîte, manuel et télécommande — imprimés à vos couleurs. Nous coordonnons avec votre équipe design ou la nôtre." },
      { title: "Logistique mondiale", desc: "Expédition en vrac depuis entrepôts régionaux (US / UE / LATAM / Afrique). Douane et import gérés." },
      { title: "Remplacement après-vente", desc: "Programme RMA avec stock de swap régional. Unités défectueuses remplacées en moins de 5 jours ouvrés." },
    ],
    cta_title_a: "Besoin d'expédier des STBs ?",
    cta_title_b: "Devis pour votre lot.",
    cta_sub: "De 500 unités en pilote à 100 000+ déploiements — dites-nous votre géographie et votre timing.",
  },
  es: {
    overline: "Set-Top Boxes",
    title_a: "Hardware de tu marca.",
    title_b: "Precargado con tu app.",
    subtitle: "Los STBs Push2Stream se envían a tus suscriptores en tu packaging, con tu app y tu logo al arrancar. Nos encargamos del firmware, certificación, logística y reemplazo post-venta.",
    models_overline: "Tres modelos",
    models_title_a: "Elige el decodificador",
    models_title_b: "que encaja con tu audiencia.",
    fulfillment_overline: "Distribución",
    fulfillment_title: "Caja. Marca. Boot.",
    fulfillment_subtitle: "Del taller a la sala de tu cliente — gestionamos cada paso de la cadena de suministro.",
    fulfillment_steps: [
      { title: "Firmware a medida", desc: "Tu app precargada, tu marca al arrancar, tu launcher como home. Actualizaciones automáticas vía nuestro servidor OTA." },
      { title: "Packaging de marca", desc: "Caja, funda, manual y mando — todo impreso en tus colores. Coordinamos con tu equipo de diseño o el nuestro." },
      { title: "Logística global", desc: "Envíos en bulk desde almacenes regionales (US / UE / LATAM / África). Aduanas e importación gestionados." },
      { title: "Reemplazo post-venta", desc: "Programa RMA con stock de swap regional. Unidades falladas reemplazadas en menos de 5 días hábiles." },
    ],
    cta_title_a: "¿Necesitas enviar STBs?",
    cta_title_b: "Cotizamos tu lote.",
    cta_sub: "De 500 unidades de piloto a 100.000+ despliegues — cuéntanos tu geografía y plazos.",
  },
  pt: {
    overline: "Set-Top Boxes",
    title_a: "Hardware da sua marca.",
    title_b: "Pré-carregado com a sua app.",
    subtitle: "Os STBs Push2Stream são enviados aos seus subscritores na sua embalagem, com a sua app e o seu logo no arranque. Tratamos do firmware, certificação, logística e substituição pós-venda.",
    models_overline: "Três modelos",
    models_title_a: "Escolha o decoder",
    models_title_b: "que encaixa na sua audiência.",
    fulfillment_overline: "Distribuição",
    fulfillment_title: "Caixa. Marca. Boot.",
    fulfillment_subtitle: "Da caixa à sala do seu cliente — gerimos cada passo da cadeia logística.",
    fulfillment_steps: [
      { title: "Firmware à medida", desc: "A sua app pré-carregada, a sua marca no arranque, o seu launcher como home. Atualizações automáticas via o nosso servidor OTA." },
      { title: "Embalagem de marca", desc: "Caixa, capa, manual e comando — tudo impresso nas suas cores. Coordenamos com a sua equipa de design ou a nossa." },
      { title: "Logística global", desc: "Envio em bulk de armazéns regionais (EUA / UE / LATAM / África). Alfândega e importação tratados." },
      { title: "Substituição pós-venda", desc: "Programa RMA com stock de troca regional. Unidades avariadas substituídas em menos de 5 dias úteis." },
    ],
    cta_title_a: "Precisa de enviar STBs?",
    cta_title_b: "Cotamos o seu lote.",
    cta_sub: "De 500 unidades piloto a 100.000+ deployments — diga-nos a sua geografia e prazos.",
  },
};

export const STB_MODELS = {
  en: [
    { name: "P2S Lite", tier: "Entry · HD", price: "From $34/unit", specs: ["1080p Full HD", "1GB RAM · 8GB storage", "HDMI · Ethernet · Wi-Fi", "BLE remote (voice optional)"], best_for: "MDU, hospitality starter kits, ISP add-ons" },
    { name: "P2S Pro", tier: "Most popular · 4K", price: "From $59/unit", specs: ["4K HDR10 + Dolby Audio", "2GB RAM · 16GB storage", "HDMI 2.1 · Gigabit Ethernet · Wi-Fi 6", "BLE voice remote · Bluetooth audio"], best_for: "Telco IPTV, branded OTT, churches" },
    { name: "P2S Stream Max", tier: "Premium · 4K HDR", price: "From $89/unit", specs: ["4K HDR10+ · Dolby Vision · Dolby Atmos", "4GB RAM · 32GB storage", "HDMI 2.1 · 2.5Gbps Ethernet · Wi-Fi 6E", "Backlit voice remote · TV-on/off · CEC"], best_for: "Premium pay-TV operators, sports broadcasters" },
  ],
  fr: [
    { name: "P2S Lite", tier: "Entrée · HD", price: "Dès 34 $/unité", specs: ["1080p Full HD", "1 Go RAM · 8 Go stockage", "HDMI · Ethernet · Wi-Fi", "Télécommande BLE (vocale en option)"], best_for: "Habitat collectif, kits hôteliers, FAI" },
    { name: "P2S Pro", tier: "Le plus populaire · 4K", price: "Dès 59 $/unité", specs: ["4K HDR10 + Dolby Audio", "2 Go RAM · 16 Go stockage", "HDMI 2.1 · Ethernet Gigabit · Wi-Fi 6", "Télécommande vocale BLE · audio Bluetooth"], best_for: "IPTV télécom, OTT en marque blanche, églises" },
    { name: "P2S Stream Max", tier: "Premium · 4K HDR", price: "Dès 89 $/unité", specs: ["4K HDR10+ · Dolby Vision · Dolby Atmos", "4 Go RAM · 32 Go stockage", "HDMI 2.1 · Ethernet 2,5 Gbps · Wi-Fi 6E", "Télécommande rétroéclairée · TV on/off · CEC"], best_for: "Opérateurs pay-TV premium, diffuseurs sport" },
  ],
  es: [
    { name: "P2S Lite", tier: "Entrada · HD", price: "Desde $34/unidad", specs: ["1080p Full HD", "1GB RAM · 8GB almacenamiento", "HDMI · Ethernet · Wi-Fi", "Mando BLE (voz opcional)"], best_for: "MDU, hotelería, kits ISP" },
    { name: "P2S Pro", tier: "Más popular · 4K", price: "Desde $59/unidad", specs: ["4K HDR10 + Dolby Audio", "2GB RAM · 16GB almacenamiento", "HDMI 2.1 · Ethernet Gigabit · Wi-Fi 6", "Mando voz BLE · audio Bluetooth"], best_for: "IPTV telco, OTT de marca, iglesias" },
    { name: "P2S Stream Max", tier: "Premium · 4K HDR", price: "Desde $89/unidad", specs: ["4K HDR10+ · Dolby Vision · Dolby Atmos", "4GB RAM · 32GB almacenamiento", "HDMI 2.1 · Ethernet 2,5 Gbps · Wi-Fi 6E", "Mando con retroiluminación · TV on/off · CEC"], best_for: "Operadores pay-TV premium, deportes" },
  ],
  pt: [
    { name: "P2S Lite", tier: "Entrada · HD", price: "Desde $34/unidade", specs: ["1080p Full HD", "1GB RAM · 8GB armazenamento", "HDMI · Ethernet · Wi-Fi", "Comando BLE (voz opcional)"], best_for: "MDU, hotelaria, kits ISP" },
    { name: "P2S Pro", tier: "Mais popular · 4K", price: "Desde $59/unidade", specs: ["4K HDR10 + Dolby Audio", "2GB RAM · 16GB armazenamento", "HDMI 2.1 · Ethernet Gigabit · Wi-Fi 6", "Comando voz BLE · áudio Bluetooth"], best_for: "IPTV telco, OTT de marca, igrejas" },
    { name: "P2S Stream Max", tier: "Premium · 4K HDR", price: "Desde $89/unidade", specs: ["4K HDR10+ · Dolby Vision · Dolby Atmos", "4GB RAM · 32GB armazenamento", "HDMI 2.1 · Ethernet 2,5 Gbps · Wi-Fi 6E", "Comando retroiluminado · TV on/off · CEC"], best_for: "Operadores pay-TV premium, desporto" },
  ],
};

// About / Company page content
export const ABOUT_PAGE = {
  en: {
    overline: "About Push2Stream",
    title_a: "Launch your OTT streaming service",
    title_b: "everywhere people stream.",
    subtitle: "A carrier-grade OTT/IPTV infrastructure company. We build the apps, the playout, the CDN that put your service on every screen, from streaming devices to a hotel room TV in Lagos.",
    mission_overline: "Mission",
    mission_title: "Make great streaming infrastructure boring.",
    mission_body: "The boring part is the point. Buffer-free playback, identical UX on every device, payments that just work, DRM that doesn't blink at studio negotiations. Boring infrastructure is what lets your audience forget the technology and remember the content.",
    vision_overline: "Vision",
    vision_title: "Every broadcaster, on every screen, in every country.",
    vision_body: "We believe TV-grade streaming should be available to a 12-channel church network in Accra and a national news broadcaster in Manila for the same per-viewer cost. Push2Stream's job is to make that math work.",
    timeline_overline: "Milestones",
    timeline_title_a: "Twelve years of",
    timeline_title_b: "shipping channels.",
    timeline: [
      { year: "2013", title: "Founded in Columbia, MD", desc: "First IPTV/OTT deployment for a regional faith network." },
      { year: "2016", title: "MoxyPlay launches", desc: "Cloud playout product replaces hardware racks for 30+ broadcasters." },
      { year: "2019", title: "Multi-platform parity", desc: "Native apps across Roku, Apple TV, Fire TV, Samsung, LG, Android TV." },
      { year: "2021", title: "Global CDN expansion", desc: "POPs in US, EU, LATAM and Africa. Sub-300ms TTFB in 40+ countries." },
      { year: "2023", title: "Push Core middleware", desc: "Unified subscriber, content, billing and analytics platform launches." },
      { year: "2026", title: "Set-Top Box program", desc: "Branded STB hardware fulfillment in 9 countries. Push2Stream now ships boxes." },
    ],
    values_overline: "Values",
    values_title: "How we work.",
    values: [
      { title: "Ship in weeks, not quarters", desc: "Starter customers launch in under 14 days. We refuse roadmap theater." },
      { title: "Carrier-grade by default", desc: "99.99% SLA isn't an upsell. It's the floor of every plan we sell." },
      { title: "No platform lock-in", desc: "Your apps, content and subscriber data are yours — exportable in standard formats, always." },
      { title: "Stay calm during outages", desc: "Our NOC runs 24/7 with auto-failover, multi-region replication and a single phone number that rings a human." },
    ],
    leadership_overline: "Leadership",
    leadership_title: "The team behind your stream.",
    leadership_sub: "Engineers, broadcast veterans and product builders who've shipped TV at carrier scale. Reach out to set up a call.",
    stats_title: "Push2Stream in numbers",
    stats: [
      { value: "12+", label: "Years in OTT/IPTV" },
      { value: "120+", label: "Channels powered" },
      { value: "40+", label: "Countries served" },
      { value: "16+", label: "Platforms shipped on" },
    ],
    cta_title_a: "Like what you see?",
    cta_title_b: "Let's build something.",
  },
  fr: {
    overline: "À propos",
    title_a: "Déployez votre plateforme OTT",
    title_b: "partout où votre audience regarde du contenu.",
    subtitle: "Une société d'infrastructure OTT/IPTV de classe opérateur. Nous construisons les applis, le playout, le CDN qui mettent votre service sur chaque écran, des appareils de streaming à une TV de chambre d'hôtel à Lagos.",
    mission_overline: "Mission",
    mission_title: "Rendre l'infrastructure de streaming invisible.",
    mission_body: "Invisible, c'est tout l'enjeu. Lecture sans buffer, UX identique sur chaque appareil, paiements qui fonctionnent, DRM qui passe les audits studios sans broncher. Une infrastructure qui s'efface, c'est ce qui permet à votre audience d'oublier la technologie et de se souvenir du contenu.",
    vision_overline: "Vision",
    vision_title: "Chaque diffuseur, sur chaque écran, dans chaque pays.",
    vision_body: "Nous pensons que le streaming de niveau TV doit être accessible à un réseau religieux de 12 chaînes à Accra et à un diffuseur national à Manille au même coût par spectateur. Le job de Push2Stream, c'est de faire fonctionner cette équation.",
    timeline_overline: "Étapes",
    timeline_title_a: "Douze ans à",
    timeline_title_b: "livrer des chaînes.",
    timeline: [
      { year: "2013", title: "Fondée à Columbia, MD", desc: "Premier déploiement IPTV/OTT pour un réseau religieux régional." },
      { year: "2016", title: "Lancement de MoxyPlay", desc: "Le playout cloud remplace les racks matériels pour 30+ diffuseurs." },
      { year: "2019", title: "Parité multi-plateforme", desc: "Applis natives sur Roku, Apple TV, Fire TV, Samsung, LG, Android TV." },
      { year: "2021", title: "Expansion CDN globale", desc: "POPs en US, UE, LATAM et Afrique. TTFB < 300 ms dans 40+ pays." },
      { year: "2023", title: "Middleware Push Core", desc: "Plateforme unifiée abonnés, contenu, facturation et analytique." },
      { year: "2026", title: "Programme Set-Top Box", desc: "Hardware STB en marque blanche dans 9 pays. Push2Stream livre désormais les boîtes." },
    ],
    values_overline: "Valeurs",
    values_title: "Comment nous travaillons.",
    values: [
      { title: "Livrer en semaines, pas en trimestres", desc: "Les clients Starter sont en ligne en moins de 14 jours. Pas de roadmap fantôme, pas de promesses qui glissent." },
      { title: "Classe opérateur par défaut", desc: "Le SLA 99,99 % n'est pas un upsell. C'est le plancher de chaque plan." },
      { title: "Pas de lock-in", desc: "Vos applis, contenus et données abonnés sont à vous — exportables en formats standard, toujours." },
      { title: "Rester calme en cas de panne", desc: "Notre NOC tourne 24/7 avec failover auto, réplication multi-région et un numéro de téléphone qui aboutit sur un humain." },
    ],
    leadership_overline: "Leadership",
    leadership_title: "L'équipe derrière votre flux.",
    leadership_sub: "Ingénieurs, vétérans du broadcast et experts produit qui ont livré de la TV à l'échelle opérateur. Contactez-nous pour planifier un appel.",
    stats_title: "Push2Stream en chiffres",
    stats: [
      { value: "12+", label: "Années dans l'OTT/IPTV" },
      { value: "120+", label: "Chaînes propulsées" },
      { value: "40+", label: "Pays servis" },
      { value: "16+", label: "Plateformes livrées" },
    ],
    cta_title_a: "Ça vous parle ?",
    cta_title_b: "Construisons quelque chose.",
  },
  es: {
    overline: "Sobre nosotros",
    title_a: "Lleva tu plataforma OTT",
    title_b: "a cualquier lugar donde tu audiencia vea contenido.",
    subtitle: "Una empresa de infraestructura OTT/IPTV de nivel operador. Construimos las apps, el playout, el CDN que ponen tu servicio en cada pantalla, desde dispositivos de streaming hasta una TV de habitación de hotel en Lagos.",
    mission_overline: "Misión",
    mission_title: "Hacer invisible la infraestructura de streaming.",
    mission_body: "Invisible es el objetivo. Reproducción sin buffer, UX idéntica en cada dispositivo, pagos que funcionan, DRM que pasa las auditorías de los estudios sin parpadear. Una infraestructura que se borra es lo que permite a tu audiencia olvidar la tecnología y recordar el contenido.",
    vision_overline: "Visión",
    vision_title: "Cada broadcaster, en cada pantalla, en cada país.",
    vision_body: "Creemos que el streaming nivel TV debería estar disponible para una red religiosa de 12 canales en Accra y para un broadcaster nacional en Manila al mismo costo por espectador. El trabajo de Push2Stream es hacer que esa matemática funcione.",
    timeline_overline: "Hitos",
    timeline_title_a: "Doce años",
    timeline_title_b: "lanzando canales.",
    timeline: [
      { year: "2013", title: "Fundada en Columbia, MD", desc: "Primer despliegue IPTV/OTT para una red religiosa regional." },
      { year: "2016", title: "Lanzamiento de MoxyPlay", desc: "El playout en la nube reemplaza racks de hardware en 30+ broadcasters." },
      { year: "2019", title: "Paridad multi-plataforma", desc: "Apps nativas en Roku, Apple TV, Fire TV, Samsung, LG, Android TV." },
      { year: "2021", title: "Expansión CDN global", desc: "POPs en US, UE, LATAM y África. TTFB < 300 ms en 40+ países." },
      { year: "2023", title: "Middleware Push Core", desc: "Plataforma unificada de suscriptores, contenido, facturación y analítica." },
      { year: "2026", title: "Programa Set-Top Box", desc: "Hardware STB de marca propia en 9 países. Push2Stream ahora envía cajas." },
    ],
    values_overline: "Valores",
    values_title: "Cómo trabajamos.",
    values: [
      { title: "Lanzar en semanas, no trimestres", desc: "Los clientes Starter lanzan en menos de 14 días. Sin teatro de roadmap." },
      { title: "Nivel operador por defecto", desc: "El SLA 99,99 % no es un upsell. Es el suelo de cada plan." },
      { title: "Sin lock-in", desc: "Tus apps, contenido y datos de suscriptores son tuyos — exportables en formatos estándar, siempre." },
      { title: "Calma durante caídas", desc: "Nuestro NOC opera 24/7 con failover automático, replicación multi-región y un teléfono que contesta un humano." },
    ],
    leadership_overline: "Liderazgo",
    leadership_title: "El equipo detrás de tu stream.",
    leadership_sub: "Ingenieros, veteranos del broadcast y constructores de producto que han lanzado TV a escala operadora. Escríbenos para agendar una llamada.",
    stats_title: "Push2Stream en números",
    stats: [
      { value: "12+", label: "Años en OTT/IPTV" },
      { value: "120+", label: "Canales activos" },
      { value: "40+", label: "Países servidos" },
      { value: "16+", label: "Plataformas soportadas" },
    ],
    cta_title_a: "¿Te resuena?",
    cta_title_b: "Construyamos algo.",
  },
  pt: {
    overline: "Sobre nós",
    title_a: "Leve a sua plataforma OTT",
    title_b: "para onde quer que o seu público assista a conteúdo.",
    subtitle: "Uma empresa de infraestrutura OTT/IPTV de nível operador. Construímos as apps, o playout, o CDN que põem o seu serviço em cada ecrã, dos dispositivos de streaming a uma TV de quarto de hotel em Lagos.",
    mission_overline: "Missão",
    mission_title: "Tornar a infraestrutura de streaming invisível.",
    mission_body: "Invisível é o objetivo. Reprodução sem buffer, UX idêntica em cada dispositivo, pagamentos que funcionam, DRM que passa as auditorias dos estúdios sem pestanejar. Uma infraestrutura que se apaga é o que permite à sua audiência esquecer a tecnologia e lembrar-se do conteúdo.",
    vision_overline: "Visão",
    vision_title: "Cada emissora, em cada ecrã, em cada país.",
    vision_body: "Acreditamos que streaming de nível TV deve estar disponível para uma rede religiosa de 12 canais em Accra e para uma emissora nacional em Manila ao mesmo custo por espectador. O trabalho da Push2Stream é fazer essa matemática funcionar.",
    timeline_overline: "Marcos",
    timeline_title_a: "Doze anos",
    timeline_title_b: "a lançar canais.",
    timeline: [
      { year: "2013", title: "Fundada em Columbia, MD", desc: "Primeiro deployment IPTV/OTT para uma rede religiosa regional." },
      { year: "2016", title: "Lançamento do MoxyPlay", desc: "O playout na nuvem substitui racks de hardware em 30+ emissoras." },
      { year: "2019", title: "Paridade multi-plataforma", desc: "Apps nativas em Roku, Apple TV, Fire TV, Samsung, LG, Android TV." },
      { year: "2021", title: "Expansão CDN global", desc: "POPs em EUA, UE, LATAM e África. TTFB < 300 ms em 40+ países." },
      { year: "2023", title: "Middleware Push Core", desc: "Plataforma unificada de subscritores, conteúdo, faturação e analítica." },
      { year: "2026", title: "Programa Set-Top Box", desc: "Hardware STB de marca própria em 9 países. A Push2Stream agora envia caixas." },
    ],
    values_overline: "Valores",
    values_title: "Como trabalhamos.",
    values: [
      { title: "Entregar em semanas, não trimestres", desc: "Clientes Starter ficam ao vivo em menos de 14 dias. Sem roadmaps fantasma, sem promessas que escorregam." },
      { title: "Nível operador por defeito", desc: "O SLA 99,99 % não é um upsell. É o piso de cada plano." },
      { title: "Sem lock-in", desc: "As suas apps, conteúdo e dados de subscritores são seus — exportáveis em formatos padrão, sempre." },
      { title: "Manter a calma nas falhas", desc: "O nosso NOC opera 24/7 com failover automático, replicação multi-região e um telefone que é atendido por humano." },
    ],
    leadership_overline: "Liderança",
    leadership_title: "A equipa por trás da sua stream.",
    leadership_sub: "Engenheiros, veteranos de broadcast e construtores de produto que entregaram TV à escala operadora. Contacte-nos para marcar uma chamada.",
    stats_title: "Push2Stream em números",
    stats: [
      { value: "12+", label: "Anos em OTT/IPTV" },
      { value: "120+", label: "Canais ativos" },
      { value: "40+", label: "Países atendidos" },
      { value: "16+", label: "Plataformas suportadas" },
    ],
    cta_title_a: "Gosta do que vê?",
    cta_title_b: "Vamos construir algo.",
  },
};

// Reference customers (case study brand cards)
export const REFERENCE_CLIENTS = [
  {
    brand: "Nema TV",
    logo: "https://customer-assets-rejwkqb3.emergentagent.net/job_push2stream-redesign/artifacts/9efja579_NEMA%20TV%20%281%29-min.png",
    category: "Global TV & Diaspora",
    region: "Worldwide",
    color: "#B84DF4",
    stat: "Live TV · News · Culture",
    url: "https://www.nematv.com",
    caseStudy: "nema-tv",
    description: {
      en: "An international live television streaming service and mobile application broadcasting global channels, news and cultural programming from home countries to expatriate communities worldwide.",
      fr: "Un service international de télévision en direct et une application mobile qui diffusent des chaînes mondiales, l'actualité et la programmation culturelle des pays d'origine aux communautés expatriées à travers le monde.",
      es: "Un servicio internacional de televisión en vivo y aplicación móvil que transmite canales globales, noticias y programación cultural desde los países de origen a las comunidades expatriadas en todo el mundo.",
      pt: "Um serviço internacional de televisão ao vivo e aplicação móvel que transmite canais globais, notícias e programação cultural dos países de origem para as comunidades expatriadas em todo o mundo.",
    },
  },
  {
    brand: "Habali TV",
    logo: "https://customer-assets.emergentagent.com/job_push2stream-redesign/artifacts/7mrwrjls_2026-06-09_19-55-599.png",
    category: "Live TV & VOD",
    region: "USA · Canada · UK",
    color: "#9B5DE5",
    stat: "Live TV + Video on Demand",
    url: "https://www.habalitv.com",
    caseStudy: "habali-tv",
    description: {
      en: "The ultimate streaming destination for the diaspora. Watch live TV, news and culture from around the world — anywhere in the world.",
      fr: "La destination de streaming ultime pour la diaspora. Regardez la TV en direct, l'actualité et la culture du monde entier — où que vous soyez.",
      es: "El destino definitivo de streaming para la diáspora. Mira TV en vivo, noticias y cultura de todo el mundo — desde cualquier lugar.",
      pt: "O destino de streaming definitivo para a diáspora. Assista TV ao vivo, notícias e cultura de todo o mundo — de qualquer lugar.",
    },
  },
  { brand: "Velocity Sports", category: "Sports & Events", region: "EMEA", color: "#F77F00", stat: "Sub-3s latency · PPV" },
  {
    brand: "MoxyPlay",
    logo: "https://customer-assets-rejwkqb3.emergentagent.net/job_push2stream-redesign/artifacts/z4tnptxj_FullLogo.png",
    category: "Cloud Playout",
    region: "Global",
    color: "#E040FB",
    stat: "Ready-to-broadcast channels",
    description: {
      en: "MoxyPlay is a cloud-based playout service delivering ready-to-broadcast TV channels. Schedule, brand and go live from a browser — no rack, no encoders, no engineers.",
      fr: "MoxyPlay est un service de playout cloud qui livre des chaînes TV prêtes à diffuser. Planifiez, personnalisez et passez en direct depuis un navigateur — sans rack, sans encodeurs, sans ingénieurs.",
      es: "MoxyPlay es un servicio de playout en la nube que entrega canales de TV listos para emitir. Programa, marca y emite en vivo desde un navegador — sin rack, sin codificadores, sin ingenieros.",
      pt: "MoxyPlay é um serviço de playout na nuvem que entrega canais de TV prontos para transmitir. Programe, personalize e vá ao ar a partir de um navegador — sem rack, sem codificadores, sem engenheiros.",
    },
  },
  { brand: "FitStream Coaches", category: "Health & Fitness", region: "USA · UK", color: "#1FA8FF", stat: "Cohort live + VOD library" },
  {
    brand: "Smiles of Loudoun Dentistry",
    logo: "https://customer-assets-rejwkqb3.emergentagent.net/job_push2stream-redesign/artifacts/kbh0vkd2_Smiles%20Of%20Loudoun%202%20logo%20300.jpg",
    category: "Enterprise & Local Business",
    region: "Leesburg, Virginia",
    color: "#F5D06F",
    stat: "Family Practice Dentistry",
    url: "https://www.smilesofloudoun.com",
    caseStudy: "smiles-of-loudoun",
    description: {
      en: "A family and cosmetic dental practice located in Leesburg, Virginia, serving patients throughout Northern Virginia with in-office patient TV and digital signage.",
      fr: "Un cabinet dentaire familial et esthétique situé à Leesburg, Virginie, qui prend en charge les patients de toute la Virginie du Nord avec TV patient et affichage numérique en cabinet.",
      es: "Una consulta dental familiar y estética ubicada en Leesburg, Virginia, que atiende a pacientes de todo el norte de Virginia con TV para pacientes y señalización digital en la clínica.",
      pt: "Um consultório odontológico familiar e estético localizado em Leesburg, Virgínia, atendendo pacientes em todo o norte da Virgínia com TV para pacientes e sinalização digital no consultório.",
    },
  },
];
